import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, updateProfile } from "firebase/auth";
import { initializeApp, deleteApp, getApps } from "firebase/app";
import { auth, firebaseConfig } from "./config.js";
import { getUserProfile, saveUserProfile } from "./firestore.js";

export async function loginWithEmail(email, password) {
  const credential = await signInWithEmailAndPassword(auth, email, password);
  const profile = await getUserProfile(credential.user.uid);

  if (!profile) {
    await signOut(auth);
    throw new Error("No user profile found. Please ask admin to add your user record.");
  }

  if (!profile.active) {
    await signOut(auth);
    throw new Error("Your account is inactive. Please contact admin.");
  }

  return { firebaseUser: credential.user, profile };
}

export function logoutUser() {
  return signOut(auth);
}

export function observeAuth(callback) {
  return onAuthStateChanged(auth, async (firebaseUser) => {
    if (!firebaseUser) {
      callback({ firebaseUser: null, profile: null, loading: false });
      return;
    }

    try {
      const profile = await getUserProfile(firebaseUser.uid);
      if (!profile?.active) {
        await signOut(auth);
        callback({ firebaseUser: null, profile: null, loading: false });
        return;
      }
      callback({ firebaseUser, profile, loading: false });
    } catch (error) {
      callback({ firebaseUser: null, profile: null, loading: false, error });
    }
  });
}

export async function createLoginUserProfile({ name, email, password, role, active }) {
  const secondaryName = "admin-user-create";
  const existing = getApps().find((item) => item.name === secondaryName);
  const secondaryApp = existing || initializeApp(firebaseConfig, secondaryName);
  const secondaryAuth = getAuth(secondaryApp);

  try {
    const credential = await createUserWithEmailAndPassword(secondaryAuth, email.trim(), password);
    if (name?.trim()) {
      await updateProfile(credential.user, { displayName: name.trim() });
    }
    await saveUserProfile(credential.user.uid, {
      name: name.trim(),
      email: email.trim(),
      role,
      active
    });
    await signOut(secondaryAuth);
    return credential.user.uid;
  } finally {
    if (!existing) {
      await deleteApp(secondaryApp).catch(() => {});
    }
  }
}
